import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { EnvironmentService } from '../_services/environment.service';
import { SearchParameters } from '../_viewmodels/search-params.viewmodel';
import { SearchService } from '../_services/search.service';
import { AuthenticationService } from '../_services/authentication.service';
import { ProfileService } from '../_services/profiles.service';
import { Profile } from '../_models/profile.model';
import { Subscription } from 'rxjs';
import { User } from '../_models/user.model';

@Component({
  selector: 'app-visor-tramite',
  templateUrl: './visor-tramite.component.html',
  styleUrls: ['./visor-tramite.component.scss'],
  providers: [SearchService],
})
export class VisorTramiteComponent implements OnInit {
  pf: number;
  radicado: string;
  currentUser: User;
  currentProfile: Profile;
  profileSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private envService: EnvironmentService,
    private searchService: SearchService,
    private authService: AuthenticationService,
    private profileService: ProfileService
  ) {}

  ngOnInit() {
    this.currentProfile = this.profileService.getSelectedProfile();
    const ifr: HTMLIFrameElement = document.createElement('iframe');
    ifr.setAttribute('id', 'embeeded-frame');
    ifr.setAttribute('frameborder', '0');
    document.getElementById('iframe-goes-here').appendChild(ifr);
    this.route.params.subscribe((params: Params) => {
      this.route.queryParams.subscribe((queryParams: Params) => {
        this.radicado = this.route.snapshot.paramMap.get('radicado');
        this.pf = queryParams['pf'];
        const searchParameters: SearchParameters = new SearchParameters();
        searchParameters.radicado = this.radicado;
        this.currentUser = this.authService.currentUserValue;
        if (this.currentProfile && this.currentUser) {
          // Asignar Perfil Actual
          searchParameters.currentProfileName = this.currentProfile.profile_name
            ? this.currentProfile.profile_name
            : '';
          // Asignar Tipo Identificacion Afiliado
          searchParameters.tipoIdfAfiliado = this.currentUser.TipoIdentificacion
            ? this.currentUser.TipoIdentificacion
            : '';
          // Asignar Número Identificación Afiliado
          searchParameters.idfAfiliado = this.currentUser.NoIdentificacion
            ? this.currentUser.NoIdentificacion
            : '';
          // Asignar Número de Identificación Empresa
          searchParameters.idfEmpresa = this.currentProfile.profile_company_id
            ? this.currentProfile.profile_company_id
            : '';
        }
        console.log(this.currentProfile);
        console.log(this.currentUser);
        let iframeURL = this.envService.tvURL + this.radicado;
        ifr.contentWindow.location.replace(iframeURL);
        console.log(iframeURL);
      });
    });
  }
}
